<template>
    <Navbar></Navbar>
    <div class="content-wrapper">
        <div class="main-content">

            <TermsTabs />

        </div>
        <FooterItem />
    </div>
</template>

<script>
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import TermsTabs from "@/components/TermsSection.vue/TermsTabs.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
    components: {
        Navbar,
        TermsTabs,
        FooterItem,
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
    },
    methods: {
        updateHeadMeta() {
            const title =
                this.currentLanguage === "ar"
                    ? "شروط الخصوصية - Planning Force | نحن نحترم خصوصيتك"
                    : "Privacy Terms - Planning Force | We Respect Your Privacy";

            const description =
                this.currentLanguage === "ar"
                    ? "تعرف على شروط الخصوصية المتعلقة بكيفية جمعنا واستخدامنا وحمايتنا لمعلوماتك الشخصية."
                    : "Learn about the privacy terms regarding how we collect, use, and protect your personal information.";

            const keywords =
                this.currentLanguage === "ar"
                    ? "شروط الخصوصية, حماية البيانات, معلومات شخصية, Planning Force"
                    : "privacy terms, data protection, personal information, Planning Force";

            useHead({
                title: title,
                meta: [
                    { name: "description", content: description },
                    { name: "keywords", content: keywords },
                    { name: "robots", content: "index, follow" },
                    {
                        name: "author",
                        content:
                            this.currentLanguage === "ar"
                                ? "معهد Planning Force العالي للتدريب"
                                : "Planning Force High Institute for Training",
                    },
                    {
                        name: "language",
                        content: this.currentLanguage === "ar" ? "ar" : "en",
                    },

                    // Open Graph meta tags
                    { property: "og:title", content: title },
                    { property: "og:description", content: description },
                    {
                        property: "og:image",
                        content: "https://example.com/privacy-og-image.jpg", // Replace with your Privacy Terms page image URL
                    },
                    { property: "og:url", content: "https://example.com/privacy" }, // Replace with your Privacy Terms page URL
                    { property: "og:type", content: "website" },

                    // Twitter Card meta tags
                    { name: "twitter:card", content: "summary_large_image" },
                    { name: "twitter:title", content: title },
                    { name: "twitter:description", content: description },
                    {
                        name: "twitter:image",
                        content: "https://example.com/privacy-twitter-image.jpg", // Replace with your Privacy Terms page image URL
                    },
                ],
            });
        },
    },
    mounted() {
        this.updateHeadMeta();
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                //  this.language = newLang;
                this.updateHeadMeta();
                store.dispatch("categoriesList");
            },
            immediate: true, // Run the handler immediately when the component is mounted
        },
    },
};
</script>